import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Drawer } from '@linktivity/link-ui';

import { Station } from '@link/shinkansen/services/types';

import styles from './stationPicker.module.css';

interface StationPickerProps {
  visible: boolean;
  title: string;
  stations: Station[];
  /** Station currently selected for the field being edited */
  selectedCode?: string;
  /** The opposite field's station — disabled so from/to can't match */
  excludeCode?: string;
  onSelect: (station: Station) => void;
  onClose: () => void;
}

const StationPicker = ({
  visible,
  title,
  stations,
  selectedCode,
  excludeCode,
  onSelect,
  onClose
}: StationPickerProps) => {
  const { t } = useTranslation();

  return (
    <Drawer visible={visible} position="bottom" onClose={onClose}>
      <div className={styles.sheet}>
        <div className={styles.header}>
          <button
            type="button"
            className={styles.close}
            aria-label={t('common.cancel')}
            onClick={onClose}
          >
            ✕
          </button>
          <span className={styles.title}>{title}</span>
        </div>

        <ul className={styles.stationList}>
          {stations.map(station => {
            const disabled = station.code === excludeCode;
            const selected = station.code === selectedCode;
            return (
              <li key={station.code}>
                <button
                  type="button"
                  className={clsx(
                    styles.stationItem,
                    selected && styles.stationItemSelected,
                    disabled && styles.stationItemDisabled
                  )}
                  disabled={disabled}
                  onClick={() => onSelect(station)}
                >
                  <span>{station.name}</span>
                  {selected && <span className={styles.check}>✓</span>}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </Drawer>
  );
};

export default StationPicker;
